// extracted by mini-css-extract-plugin
export default {"controls":"Settings_controls__T5Zx4","link":"Settings_link__StXnw"};